import React from "react";
import { message } from "antd";
import "../../Styles/Components.less";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../MainPage";
import Group from "../Group/Group";
import ServiceSimpleList from "../Service/ServiceSimpleList";
import ListServiceProvider from "./ListServiceProvider";
import ServiceProviderForm from "./ServiceProviderForm";
import GroupServiceProvider from "./GroupServiceProvider";
import { convertServiceProviderList } from "../../Helpers/ServiceProviderHelpers";
import {
  DefaultServiceProvider,
  EntityStatus,
  NavMenuItems,
  ServiceProviderActions,
} from "../../Constants/Constants";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";
import ServiceEntitlement from "../ServiceEntitlement/ServiceEntitlement";
import DeviceAssign from "./DeviceAssign";
import DeviceUnassign from "./DeviceUnassign";
import ListDeviceMangement from "../DeviceSkuManagement/ListDeviceMangement";

class ServiceProvider extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.serviceProvider.icon()}
        <span>{NavMenuItems.serviceProvider.label}</span>
      </>,
    ];
    console.log("ServiceProvider props", props);
    this.state = {
      action: null,
      record: null,
      providerData: null,
      providerDataLoading: false,
      currentProvider: null,
    };
  }

  componentDidMount() {
    this.updateServiceProviderList();
  }

  updateServiceProviderList() {
    console.log("fetchServiceProviderList...");
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });
    const errorCallback = () => {
      this.setState({ providerDataLoading: false });
      message.error("Error fetching Service Provider list");
    };
    const successCallback = (data) => {
      const providerData = convertServiceProviderList(data);
      console.log("fetchServiceProviderList data", providerData);
      this.setState({ providerData, providerDataLoading: false });
      this.setDefaultProviderId(providerData);
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateServiceProviderList();
    redirect && this.setState({ action: null, record: null });
  };
  setDefaultProviderId(providerData) {
    providerData.forEach((item) => {
      item.name === DefaultServiceProvider &&
        this.setState({ currentProvider: item.providerId });
    });
  }
  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record.providerId, !status),
      });
      if (status) {
        this.props.serviceProviderApi.activateServiceProvider(
          record.providerId,
          callback
        );
      } else {
        this.props.serviceProviderApi.inActivateServiceProvider(
          record.providerId,
          callback
        );
      }
      this.changeStatus(record.providerId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  changeStatus = (providerId, status) => {
    const providerData = [...this.state.providerData];
    providerData.forEach((prov) => {
      if (prov.providerId === providerId) {
        prov.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
      }
    });
    this.setState({ providerData });
  };

  render() {
    const {
      action,
      record,
      providerData,
      providerDataLoading,
      currentProvider,
    } = this.state;
    return (
      <MainPage>
        <div className="service-provider-container">
          {!action ? (
            <ListServiceProvider
              providerDataLoading={providerDataLoading}
              providerData={providerData}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.service ? (
            <ServiceSimpleList
              serviceProviderRecord={record}
              onParentActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.devices ? (
            <ListDeviceMangement
              selectedProvider={record.providerId}
              selectedProviderName={record.name}
              parentBread={this.header}
              serviceProviderRecord={record}
              onActionClick={this.onActionClick}
              currentProvider={currentProvider}
            />
          ) : action === ServiceProviderActions.deviceGroup ? (
            <Group
              serviceProviderRecord={record}
              onParentActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.entitlement ? (
            <ServiceEntitlement
              serviceProviderRecord={record}
              onParentActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.group ? (
            <GroupServiceProvider
              record={record}
              providerData={providerData}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.assignDevice ? (
            <DeviceAssign
              record={record}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === ServiceProviderActions.unassignDevice ? (
            <DeviceUnassign
              record={record}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : (
            <ServiceProviderForm
              action={action}
              record={record}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

ServiceProvider.propTypes = {
  serviceProviderApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
});
const connectedServiceProvider = connect(mapStateToProps)(ServiceProvider);
export default withRouter(connectedServiceProvider);
